import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

/**
 * DevicesPage - Displays all platforms and devices where ElectricNOW is available
 * Mirrors content from https://www.electricnow.tv/devices with app-consistent styling
 */
const DevicesPage = () => {
  // App download platforms
  const downloadPlatforms = [
    {
      name: 'Roku',
      url: 'https://channelstore.roku.com/details/294381/electricnow',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
        </svg>
      ),
    },
    {
      name: 'Apple TV',
      url: 'https://itunes.apple.com/us/app/id1501030946',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'iOS',
      subtitle: 'iPhone & iPad',
      url: 'https://itunes.apple.com/us/app/id1501030946',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
      ),
    },
    {
      name: 'LG Smart TV',
      url: 'https://us.lgappstv.com/main/tvapp/detail?appId=1193498',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'Hisense',
      url: 'https://www.electricnow.tv/devices',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'Xfinity',
      url: 'https://www.electricnow.tv/devices',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
    },
    {
      name: 'Vizio',
      url: 'https://www.electricnow.tv/devices',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'Samsung Smart TV',
      url: 'https://www.electricnow.tv/devices',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'Android TV',
      url: 'https://play.google.com/store/apps/details?id=com.electric.now.tv',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 17H3V5h18m0-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      ),
    },
    {
      name: 'Fire TV',
      url: 'https://www.amazon.com/dp/B08L5VDQZ1',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
        </svg>
      ),
    },
    {
      name: 'Android',
      subtitle: 'Phone & Tablet',
      url: 'https://play.google.com/store/apps/details?id=com.electric.now',
      icon: (
        <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
        </svg>
      ),
    },
  ];

  // Live channel platforms with channel numbers/instructions
  const liveChannelPlatforms = [
    { name: 'Roku TV', channel: '349', section: 'TV Dramas', url: 'https://channelstore.roku.com/details/294381/electricnow' },
    { name: 'Sling TV', section: 'Entertainment', url: 'https://www.sling.com/' },
    { name: 'Samsung TV Plus', channel: '1074', url: 'https://www.samsung.com/us/televisions-home-theater/tvs/tvplus/' },
    { name: 'Freevee (IMDB)', section: 'Entertainment', url: 'https://www.amazon.com/freevee' },
    { name: 'TCL Channel', section: 'Movies & TV Series', url: 'https://www.tcl.com/' },
    { name: 'DistroTV', section: 'Entertainment', url: 'https://www.distro.tv/' },
    { name: 'Vidgo', section: 'Entertainment', url: 'https://www.vidgo.com/' },
    { name: 'Stremium', channel: '104', url: 'https://www.stremium.com/' },
    { name: 'Xperi TiVo', section: 'Entertainment', url: 'https://www.tivo.com/' },
    { name: 'Vidaa', section: 'Entertainment', url: 'https://www.vidaa.com/' },
    { name: 'MyBundle TV', channel: '004', section: 'TV & Movies', url: 'https://www.mybundle.tv/' },
    { name: 'Local Now', channel: '1616', section: 'Movies & TV', url: 'https://www.localnow.com/' },
    { name: 'Stirr', channel: '305', section: 'Entertainment', url: 'https://www.stirr.com/' },
    { name: 'Xumo', section: 'Action & Drama', url: 'https://www.xumo.tv/' },
    { name: 'LG Channels', channel: '314', url: 'https://www.lg.com/us/lg-channels' },
    { name: 'Redbox', section: 'Action, Sci-Fi & Horror', url: 'https://www.redbox.com/' },
    { name: 'Freecast', section: 'Entertainment', url: 'https://www.freecast.com/' },
    { name: 'Plex', section: 'Entertainment', url: 'https://www.plex.tv/' },
    { name: 'Vizio WatchFree+', channel: '716', url: 'https://www.vizio.com/' },
  ];

  // Spanish channel platforms
  const spanishPlatforms = [
    { name: 'TCL Channel', url: 'https://www.tcl.com/' },
    { name: 'DistroTV', url: 'https://www.distro.tv/' },
    { name: 'Plex', url: 'https://www.plex.tv/' },
    { name: 'Freecast', url: 'https://www.freecast.com/' },
    { name: 'Vidaa', url: 'https://www.vidaa.com/' },
    { name: 'Local Now', url: 'https://www.localnow.com/' },
    { name: 'MyBundle TV', url: 'https://www.mybundle.tv/' },
    { name: 'Sling TV', url: 'https://www.sling.com/' },
    { name: 'Mometu', url: 'https://www.mometu.com/' },
  ];

  return (
    <div className="min-h-screen bg-page">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#2f6eb0]/20 via-transparent to-transparent"></div>
        <div className="relative z-10 max-w-6xl px-6 mx-auto text-center">
          <h1 className="mb-6 text-5xl font-display tracking-[0.2em] uppercase text-white md:text-6xl">
            Devices
          </h1>
          <p className="max-w-3xl mx-auto text-xl text-gray-300">
            Watch ElectricNOW anywhere, anytime. Download our free app or find us on your favorite streaming platform.
          </p>
        </div>
      </section>

      {/* Download App Section */}
      <section className="py-16 bg-gradient-to-b from-transparent to-gray-900/50">
        <div className="max-w-6xl px-6 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-display tracking-[0.15em] uppercase text-white md:text-4xl">
              Download the Free App Today
            </h2>
            <p className="text-gray-400">
              Get ElectricNOW on your favorite device for the best streaming experience
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {downloadPlatforms.map((platform, index) => (
              <a
                key={index}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center p-5 transition-all duration-300 bg-gray-800/50 border border-gray-700/50 rounded-xl hover:border-[#2f6eb0] hover:bg-gray-800 hover:-translate-y-1 group"
              >
                <div className="flex items-center justify-center w-16 h-16 mb-3 text-white/70 group-hover:text-[#2f6eb0] transition-colors">
                  {platform.icon}
                </div>
                <div className="text-sm font-medium text-center text-white">{platform.name}</div>
                {platform.subtitle && (
                  <div className="text-xs text-gray-400 mt-0.5">{platform.subtitle}</div>
                )}
              </a>
            ))}
          </div>

          {/* Primary Download Buttons */}
          <div className="flex flex-wrap justify-center gap-4 mt-10">
            <a
              href="https://itunes.apple.com/us/app/id1501030946"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 text-white transition-all duration-300 bg-black border border-gray-600 rounded-lg hover:border-white hover:bg-gray-900"
            >
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <div className="text-left">
                <div className="text-xs text-gray-400">Download on the</div>
                <div className="text-lg font-semibold">App Store</div>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.electric.now"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3 text-white transition-all duration-300 bg-black border border-gray-600 rounded-lg hover:border-white hover:bg-gray-900"
            >
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="text-left">
                <div className="text-xs text-gray-400">Get it on</div>
                <div className="text-lg font-semibold">Google Play</div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Live Channel 24/7 Section */}
      <section className="py-16 bg-gray-900/30">
        <div className="max-w-6xl px-6 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-display tracking-[0.15em] uppercase text-white md:text-4xl">
              Watch the Live Channel 24/7
            </h2>
            <p className="text-gray-400">
              Find ElectricNOW on these streaming platforms for 24/7 live programming
            </p>
          </div>

          {/* Channel Guide Table */}
          <div className="overflow-hidden border border-gray-700 rounded-xl bg-gray-800/30">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-700 bg-gray-800/50">
                    <th className="px-6 py-4 text-sm font-semibold tracking-wider text-left text-white uppercase">Platform</th>
                    <th className="px-6 py-4 text-sm font-semibold tracking-wider text-left text-white uppercase">Channel / Location</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-700/50">
                  {liveChannelPlatforms.map((platform, index) => (
                    <tr 
                      key={index} 
                      className="transition-colors hover:bg-gray-800/50"
                    >
                      <td className="px-6 py-4">
                        <a 
                          href={platform.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="font-medium text-white hover:text-[#2f6eb0] transition-colors"
                        >
                          {platform.name}
                        </a>
                      </td>
                      <td className="px-6 py-4 text-gray-300">
                        {platform.channel && (
                          <span className="inline-flex items-center px-2 py-1 mr-2 text-xs font-medium text-[#2f6eb0] bg-[#2f6eb0]/10 rounded">
                            Ch. {platform.channel}
                          </span>
                        )}
                        {platform.section && (
                          <span className="text-gray-400">
                            In "Live TV" → "{platform.section}"
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Spanish Channel Section */}
      <section className="py-16">
        <div className="max-w-6xl px-6 mx-auto">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-3xl font-display tracking-[0.15em] uppercase text-white md:text-4xl">
              <span className="text-[#2f6eb0]">ElectricNOW en Español</span>
            </h2>
            <p className="text-gray-400">
              Vea ElectricNOW en Español en canal en vivo 24/7
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
            {spanishPlatforms.map((platform, index) => (
              <a
                key={index}
                href={platform.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center p-4 text-center transition-all duration-300 bg-gray-800/50 border border-gray-700/50 rounded-lg hover:border-[#2f6eb0] hover:bg-gray-800"
              >
                <span className="font-medium text-white">{platform.name}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Watch Anywhere CTA */}
      <section className="py-20 bg-gradient-to-b from-gray-900/50 to-transparent">
        <div className="max-w-4xl px-6 mx-auto text-center">
          <h2 className="mb-6 text-4xl font-display tracking-[0.2em] uppercase text-white">
            Watch Anywhere 24/7
          </h2>
          <p className="mb-8 text-xl text-gray-300">
            From classic shows like Leverage and The Librarians to action-packed movies, 
            ElectricNOW brings you the best of Electric Entertainment - completely free.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 px-8 py-4 text-lg font-bold text-white uppercase transition-all duration-300 bg-[#2f6eb0] rounded-lg hover:bg-[#3d7fcb] hover:scale-105"
          >
            Start Watching Now
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DevicesPage;

